import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { SessionService } from '../common/session.service';
import { PartnerDto, PaymentRequestDto } from '../api/models';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AngularDeviceInformationService } from 'angular-device-information';
import {  QrCodeCtlService, ReceiptControllerService } from '../api/services';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-qrcode',
  imports: [
    QRCodeComponent,
    ReactiveFormsModule
],
  templateUrl: './qrcode.component.html',
  styleUrl: './qrcode.component.css'
})
export class QrcodeComponent  implements OnInit{
 


  qrCode= 'qrcode';
  isPayment = false;
  merchant?:PartnerDto;
  formPay:FormGroup;
  paymentNetworkOtpion='';
  paymentNetwork='';
  isWallet = false;
  type ='';
  qrMessage ='';

  constructor(private session:SessionService,
    private activeRoute:ActivatedRoute,
    private qrCodeService:QrCodeCtlService,
    private formBuilder:FormBuilder,
    private deviceInfo :AngularDeviceInformationService,
    private route:Router,
    private receiptService: ReceiptControllerService
  ){
    this.formPay= this.formBuilder.group({
      amount:['',[Validators.required,Validators.min(5)]],
      phone:['']

    });

  }

  ngOnInit(): void {
   
    this.activeRoute.params.subscribe(p=>{
      this.type =p['type'];
      if(this.type =='payment'){
        this.isPayment =true;
        this.qrMessage ='Paiement pour '+this.merchant?.name;
        let idMerchant =p['idMerchant'];
        this.merchant ={
          id:idMerchant,
          name:'',
          address:'',
          phone:''
        };
      }else {
        this.isPayment = false;
        this.merchant = this.session.getSessionInfo().partner;
        this.createQrCode();
      }
    });
    
    
  }
  createQrCode(){

    let prefix = environment.qrcodeUrl;
    this.qrCode = prefix+'/'+this.merchant?.id;
    if(this.merchant?.mcc=='8299'){
      this.qrCode=environment.qrCodeSchool+"?idSchool="+this.merchant.id;
    }else if(this.merchant?.mcc=='8398') {
      this.qrCode=environment.frontBaseUrl+'/cotisations?idAssoc='+this.merchant?.id;
    }


  }
  loadMerchant(){

  }

  initPayment(){
        console.log(this.paymentNetwork);
        let phone = this.formPay.value.phone;
        let amnt:number = this.formPay.value.amount?this.formPay.value.amount:0;
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform( Date(), 'YYMMddHHmmss');
        let nb = Math.floor(Math.random()*1000000);
        let reqId ='qr-'+formattedDate+'-'+nb;
        console.log(reqId);
        let dto :PaymentRequestDto = {
          paymentNetwork:this.paymentNetwork!!.toUpperCase(),
          paymentMean: phone,
          paymentMethod:this.isWallet?'WALLET':'CARD',
          amount : amnt,
          merchantNumber:this.merchant?.id,
          currencyCode:'XOF',
          requestId: reqId,
          paymentNetworkOption: this.paymentNetworkOtpion!!
        };
        console.log(dto);
        this.qrCodeService.qrPayment(
           dto
        ).subscribe({
          next:(resp)=>{
            if(resp.status =='PENDING'){
              if(this.paymentNetwork.toUpperCase() == 'OMSN'){
                this.isPayment =false;
                this.isWallet =true;
                if(this.deviceInfo.isDesktop()){
                  window.open(resp.paymentUrl,'_self');
                }else {
                  this.qrCode =resp.qrCode!!;
                  this.finalizePayment(resp.reference!!);
                }
              }else{
                window.open(resp.paymentUrl,'_self');
              }
            
          }
          }
        });
  }
  isValid():boolean{
    let amnt = this.formPay.value.amount;
    let valid =amnt>0;
    if(this.paymentNetwork =='card'){
      valid = valid&&true;
    }else {
      let phone = this.formPay.value.phone;
      if(this.paymentNetwork.toUpperCase() =='OMSN'){
        if(this.deviceInfo.isDesktop()){
          this.paymentNetworkOtpion ='qrcode';
        }else {
          this.paymentNetworkOtpion='maxit';
        }

      }
      valid = phone!=null&&phone.length>=9;

    }
    return valid;
  }
  onSelectPaymentMethod(paymentNetwork:string){

    this;this.formPay.reset();
    this.paymentNetworkOtpion='';
    this.paymentNetwork = paymentNetwork;
    const methods = document.querySelectorAll('.payment-method');

    if(this.paymentNetwork == 'card'){
      this.isWallet = false;
   
    }else {
      this.isWallet =true;

    }

    methods.forEach(element => {
      
      if(element.getAttribute('data-method') == paymentNetwork){
        element.classList.add('active');

      }else {
        element.classList.remove('active');
      }
      
    });

  }
  async finalizePayment(reference:string){
    
    this.receiptService.getPaymentDetails(
      reference
    ).subscribe({
      next:(resp)=>{
        console.log(resp);
        if(resp.status =='PENDING'){
          setTimeout(()=>
            {
              this.finalizePayment(reference);
            },
            60000);
        }else {
          this.route.navigateByUrl('receipt/'+reference);
        }
        
      },
      
    });
   
  }

}
